import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "../../Styles/Itinerary.module.scss";
import picture_3 from "../../img/Israel/IPDay_3.jpg";
import picture_4 from "../../img/Israel/IPDay_4.jpg";
import picture_5 from "../../img/Israel/IPDay_5.jpg";
import picture_6 from "../../img/Israel/IPDay_6.jpg";
import picture_7 from "../../img/Israel/IPDay_7.jpg";
import picture_8 from "../../img/Israel/IPDay_8.jpg";
import picture_9 from "../../img/Israel/IPDay_9.jpg";
import picture_10 from "../../img/Israel/IPDay_10.jpg";
import picture_11 from "../../img/Israel/IPDay_11.jpg";
import picture_12 from "../../img/Israel/IPDay_12.jpeg";
import picture_13 from "../../img/Israel/IPDay_13.jpg";
import picture_14 from "../../img/Israel/IPDay_14.jpg";
//import itinerary from "../../img/Israel/Israel_Petra_Tour_2025.pdf";
import { IoClose } from "react-icons/io5";

function PetraIsraelItinerary() {
  //For day 2

  const [boxState, setBoxState] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false
  ]);
  const open = function (i) {
    const copy = [...boxState];
    copy[i] = true;
    setBoxState(copy);
  };
  const close = function (i) {
    const copy = [...boxState];
    copy[i] = false;
    setBoxState(copy);
  };

  const [justTrip, setJustTrip] = useState(false);

  const tripExample = [
    {
      day: "Day 1",
      text: ["Depart the USA"],
      extraText: [""],
      picture: ""
    },
    {
      day: "Day 2",
      text: [
        "Arrive in Tel Aviv.",
        "Stay in a hotel in Tel Aviv",
        "(overnight in Tel Aviv)"
      ],
      extraText: [],
      picture: ""
    },
    {
      day: "Day 3",
      text: [
        "Caesarea Maritima",
        "Mt. Carmel/Mukraka",
        "Megiddo",
        "Tiberias",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_3
    },
    {
      day: "Day 4",
      text: [
        "Harod Springs (Ma’ayan Harod National Park – Gideon’s Spring)",
        "Up Mt. Gilboa (Mt Shaul)",
        "Nazareth Brow",
        "Nazareth Village",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_4
    },
    {
      day: "Day 5",
      text: [
        "Mt. Arbel",
        "Holy Land Sailing/Sea of Galilee at Ginnosar and the Jesus Boat Museum",
        "Capernaum",
        "Aramos Topos (Outside of Capernaum)",
        "Mt. of Beatitudes",
        "Kursi National Park",
        "Hippos (Sussito) if time permits",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_5
    },
    {
      day: "Day 6",
      text: [
        "Tel Dan",
        "Caesarea Philippi ",
        "Nimrod’s Castle",
        "Valley of Tears",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_6
    },
    {
      day: "Day 7",
      text: [
        "Jordan River (Yardenit)",
        "Qumran",
        "Masada",
        "(overnight at Ein Bokek)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_7
    },
    {
      day: "Day 8",
      text: [
        "Ein Gedi",
        "Jerusalem—walk/tour through the Old City (overnight in Jerusalem)"
      ],
      extraText: [
        "Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_8
    },
    {
      day: "Day 9",
      text: [
        "The Temple Mount",
        "Pool of Bethesda",
        "St Anne Church ",
        "Mt. Zion: the Upper Room ",
        "Grave of Oscar Schindler",
        "St Peter Gallicantu ",
        "City of David (watch the movie)",
        "Hezekiah's Tunnel ",
        "Pool of Siloam ",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_9
    },
    {
      day: "Day 10",
      text: [
        "The Mt of Olives",
        "Pater Noster (meeting in the garden in the back)",
        "Garden of Gethsemane",
        "Walk through the Kidron Valley",
        "The Damascus Gate",
        "Garden Tomb ",
        "(overnight in Jerusalem) "
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 11",
      text: [
        "Bethlehem (Church of the Nativity)",
        "Shepherd’s Field",
        "Herodian (if time permits)",
        "Valley of Elah (David and Goliath)",
        "Joppa",
        "Last dinner at Joppa",
        "(catch late night flight to USA or the next day for those not doing th supplement trip)",
        "(For those doing the supplement trip, overnight in Jerusalem or Tel Aviv)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 12",
      text: ["Arrive back to the USA"],
      extraText: [],
      picture: ""
    }
  ];

  // SEPTEMBER TRIP
  const tripSeptember = [
    {
      day: "Day 1 - Tuesday, September 29",
      text: ["Depart the USA"],
      extraText: [""],
      picture: ""
    },
    {
      day: "Day 2 - Wednesday, September 30",
      text: [
        "Arrive in Tel Aviv.",
        "Stay in a hotel in Tel Aviv",
        "(overnight in Tel Aviv)"
      ],
      extraText: [],
      picture: ""
    },
    {
      day: "Day 3 - Thursday, October 1",
      text: [
        "Caesarea Maritima",
        "Mt. Carmel/Mukraka",
        "Megiddo",
        "Tiberias",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_3
    },
    {
      day: "Day 4 - Friday, October 2",
      text: [
        "Harod Springs (Ma’ayan Harod National Park – Gideon’s Spring)",
        "Up Mt. Gilboa (Mt Shaul)",
        "Nazareth Brow",
        "Nazareth Village",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_4
    },
    {
      day: "Day 5 - Saturday, Otober 3",
      text: [
        "Mt. Arbel",
        "Holy Land Sailing/Sea of Galilee at Ginnosar and the Jesus Boat Museum",
        "Capernaum",
        "Aramos Topos (Outside of Capernaum)",
        "Mt. of Beatitudes",
        "Kursi National Park",
        "Hippos (Sussito) if time permits",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_5
    },
    {
      day: "Day 6 - Sunday, October 4",
      text: [
        "Tel Dan",
        "Caesarea Philippi ",
        "Nimrod’s Castle",
        "Valley of Tears",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_6
    },
    {
      day: "Day 7 - Monday, October 5",
      text: [
        "Jordan River (Yardenit)",
        "Qumran",
        "Masada",
        "The Dead Sea",
        "(overnight at Ein Bokek at the Dead Sea)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_7
    },
    {
      day: "Day 8 - Tuesday, Otober 6",
      text: [
        "Ein Gedi",
        "Jerusalem—walk/tour through the Old City",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        "Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_8
    },
    {
      day: "Day 9 - Wednesday, October 7",
      text: [
        "The Temple Mount",
        "Pool of Bethesda",
        "St Anne Church ",
        "Mt. Zion: the Upper Room ",
        "Grave of Oscar Schindler",
        "St Peter Gallicantu ",
        "City of David",
        "Hezekiah's Tunnel ",
        "Pool of Siloam ",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_9
    },
    {
      day: "Day 10 - Thursday, October 8",
      text: [
        "The Mt of Olives",
        "Pater Noster (meeting in the garden in the back)",
        "Garden of Gethsemane",
        "Walk through the Kidron Valley",
        "The Damascus Gate",
        "Garden Tomb ",
        "(overnight in Jerusalem) "
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 11 - Friday, October 9",
      text: [
        "Bethlehem (Church of the Nativity)",
        "Shepherd’s Field",
        "Herodian (if time permits)",
        "Valley of Elah (David and Goliath)",
        "Joppa",
        "Last dinner at Joppa",
        "(catch late night flight to USA or the next day for those not doing the supplement trip)",
        "(For those doing the supplement trip, overnight in Tel Aviv)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 12 - Saturday, October 10",
      text: ["Arrive back to the USA"],
      extraText: [],
      picture: ""
    }
  ];
  const tripNovember = [
    {
      day: "Day 1 - Monday, November 2",
      text: ["Depart the USA"],
      extraText: [""],
      picture: ""
    },
    {
      day: "Day 2 - Tuesday, November 3",
      text: [
        "Arrive in Tel Aviv.",
        "Stay in a hotel in Netanya on the Mediterranean Coast",
        "(overnight in Netanya)"
      ],
      extraText: [],
      picture: ""
    },
    {
      day: "Day 3 - Wednesday, November 4",
      text: [
        "Caesarea Maritima",
        "Mt. Carmel/Mukraka",
        "Megiddo",
        "Tiberias",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_3
    },
    {
      day: "Day 4 - Thursday, November 5",
      text: [
        "Harod Springs (Ma’ayan Harod National Park – Gideon’s Spring)",
        "Up Mt. Gilboa (Mt Shaul)",
        "Nazareth Brow",
        "Nazareth Village",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_4
    },
    {
      day: "Day 5 - Friday, November 6",
      text: [
        "Mt. Arbel",
        "Holy Land Sailing/Sea of Galilee at Ginnosar and the Jesus Boat Museum",
        "Capernaum",
        "Aramos Topos (Outside of Capernaum)",
        "Mt. of Beatitudes",
        "Kursi National Park",
        "Hippos (Sussito) if time permits",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_5
    },
    {
      day: "Day 6 - Saturday, November 7",
      text: [
        "Tel Dan",
        "Caesarea Philippi ",
        "Nimrod’s Castle",
        "Valley of Tears",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_6
    },
    {
      day: "Day 7 - Sunday, November 8",
      text: [
        "Jordan River (Yardenit)",
        "Qumran",
        "Masada",
        "The Dead Sea",
        "(overnight at Ein Bokek at the Dead Sea)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_7
    },
    {
      day: "Day 8 - Monday, November 9",
      text: [
        "Ein Gedi",
        "Jerusalem—walk/tour through the Old City",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        "Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_8
    },
    {
      day: "Day 9 - Tuesday, November 10",
      text: [
        "The Temple Mount",
        "Pool of Bethesda",
        "St Anne Church ",
        "Mt. Zion: the Upper Room ",
        "Grave of Oscar Schindler",
        "St Peter Gallicantu ",
        "City of David",
        "Hezekiah's Tunnel ",
        "Pool of Siloam ",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_9
    },
    {
      day: "Day 10 - Wednesday, November 11",
      text: [
        "The Mt of Olives",
        "Pater Noster (meeting in the garden in the back)",
        "Garden of Gethsemane",
        "Walk through the Kidron Valley",
        "The Damascus Gate",
        "Garden Tomb ",
        "(overnight in Jerusalem) "
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 11 - Thursday, November 12",
      text: [
        "Bethlehem (Church of the Nativity)",
        "Shepherd’s Field",
        "Herodian (if time permits)",
        "Valley of Elah (David and Goliath)",
        "Joppa (time permitting)",
        "(catch late night flight to USA or the next day for those not doing thesupplement trip)",
        "(For those doing the supplement trip, overnight near airport)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 12 - Friday, November 13",
      text: ["Arrive back to the USA"],
      extraText: [],
      picture: ""
    }
  ];

  //OCTOBER TRIP
  const tripOctober = [
    {
      day: "Day 1 - Tuesday, October 20",
      text: ["Depart the USA"],
      extraText: [""],
      picture: ""
    },
    {
      day: "Day 2 - Wednesday, October 21",
      text: [
        "Arrive to Ben Gurion Airport",
        "Stay in a hotel in Tel Aviv",
        "(overnight in Tel Aviv)"
      ],
      extraText: [],
      picture: ""
    },
    {
      day: "Day 3 - Thursday, October 22",
      text: [
        "Caesarea Maritima",
        "Mt. Carmel/Mukraka",
        "Nazareth Brow",
        "Nazareth Village",
        "Tiberias",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_3
    },
    {
      day: "Day 4 - Friday, October 23",
      text: [
        "Mt. Arbel",
        "Holy Land Sailing/Sea of Galilee at Ginnosar and the Jesus Boat Museum",
        "Mt. of Beatitudes",
        "Aramos Topos (Outside of Capernaum)",
        "Kursi National Park",
        "Hippos (Sussito) if time permits",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_4
    },
    {
      day: "Day 5 - Saturday, October 24",
      text: [
        "Tel Dan",
        "Caesarea Philippi",
        "Nimrod’s Castle",
        "Valley of Tears",
        "(overnight in Tiberias)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_5
    },
    {
      day: "Day 6 - Sunday, October 25",
      text: [
        "Jordan River (Yardenit)",
        "Qumran ",
        "Masada",
        "The Dead Sea",
        "(overnight at Ein Bokek at the Dead Sea)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_6
    },
    {
      day: "Day 7 - Monday, October 26",
      text: [
        "Ein Gedi",
        "Jerusalem—walking tour through the Old City",
        "Western Wall of the Old City",
        "Jewish Quarter",
        "The Cardo",
        "The Broad Wall",
        "The Western Wall of the Temple Mount",
        "The Christian Quarter",
        "The Church of the Holy Sepulchre",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_7
    },
    {
      day: "Day 8 - Tuesday, October 27",
      text: [
        "The Mt of Olives",
        "Pater Noster (meeting in the garden in the back)",
        "Garden of Gethsemane",
        "Walk through the Kidron Valley",
        "The Damascus Gate",
        "Garden Tomb",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_8
    },
    {
      day: "Day 9 - Wednesday, October 28",
      text: [
        "The Temple Mount",
        "Pool of Bethesda",
        "St Anne Church ",
        "Mt. Zion: the Upper Room",
        "Grave of Oscar Schindler",
        "St Peter Gallicantu ",
        "City of David",
        "Hezekiah's Tunnel ",
        "Pool of Siloam ",
        "(overnight in Jerusalem)"
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_9
    },
    {
      day: "Day 10 - Thursday, October 29",
      text: [
        "Bethlehem",
        "Shepherd’s Field",
        "Herodian (if time permits)",
        "Valley of Elah (David and Goliath) ",
        "Joppa",
        "Last dinner at Joppa ",
        "(overnight near airport) "
      ],
      extraText: [
        " Our tour begins at Caesarea Maritima, constructed by Herod the Great between 22 and 10 B.C. and rich in biblical significance. For five centuries, it served as the center of Roman administration in Palestine. Among the highlights of our visit are the beautifully reconstructed theater built by Herod and the remnants of his palace situated along the Mediterranean coast. This city is notably the backdrop for the story of Cornelius as described in Acts 10, and it is also where the Apostle Paul endured two years of imprisonment.",
        "Following this, we will ascend to the summit of Mount Carmel, the site where Elijah confronted the prophets of Baal, offering us a stunning view of the Jezreel Valley.",
        "Our final destination for the day will be Tel Megiddo, known as Armageddon, a site intrinsically linked to the “end times” and the ultimate confrontation between good and evil, as referenced in Revelation 16:16."
      ],
      picture: picture_10
    },
    {
      day: "Day 11 - Friday, October 30",
      text: ["Depart for the USA", "Arrive back to the USA"],
      extraText: [],
      picture: ""
    }
  ];

  const supplementTrip = [
    {
      day: "Day 12",
      text: [
        "Drive to the Red Sea through the Negev Desert with stops at",
        "Sde Boker: view of the Wilderness of Zin and the burial place of David Ben Gurion, first prime minister of Israel",
        "Mitzpe Ramon: view from the top of the Ramon Crater",
        "(overnight at Eilat / Red Sea)"
      ]
    },
    {
      day: "Day 13",
      text: ["Day trip to Petra in Jordan", "(overnight at Eilat)"]
    },
    {
      day: "Day 14",
      text: [
        "Drive back to Tel Aviv with stops at",
        "Tabernacle at Timna Park",
        "Tel of ancient Beersheba",
        "Overnight near Tel Aviv/airport"
      ]
    },
    { day: "Day 15", text: ["Fly home"] }
  ];
  const supplementTripSeptember = [
    {
      day: "Day 12 - Saturday, October 10",
      text: [
        "Drive to the Red Sea through the Negev Desert with stops at:",
        "Sde Boker: view of the Wilderness of Zin and the burial place of David Ben Gurion, the first prime minister of Israel",
        "Mitzpe Ramon: view from the top of the Ramon Crater",
        "(overnight at Eilat / Red Sea)"
      ]
    },
    {
      day: "Day 13 - Sunday, October 11",
      text: ["Day trip to Petra in Jordan", "(overnight at Eilat)"]
    },
    {
      day: "Day 14 - Monday, October 12",
      text: [
        "Drive back to Tel Aviv with stops at:",
        "Tabernacle at Timna Park",
        "Tel of ancient Beersheba",
        "(overnight near airport/Lod)"
      ]
    },
    { day: "Day 15 - Tuesday, October 13", text: ["Fly home"] }
  ];
  const supplementTripNovember = [
    {
      day: "Day 12 - Friday, November 13",
      text: [
        "Drive to the Red Sea through the Negev Desert with stops at:",
        "Sde Boker: view of the Wilderness of Zin and the burial place of David Ben Gurion, the first prime minister of Israel",
        "Mitzpe Ramon: view from the top of the Ramon Crater",
        "(overnight at Eilat / Red Sea)"
      ]
    },
    {
      day: "Day 13 - Saturday, November 14",
      text: ["Day trip to Petra in Jordan", "(overnight at Eilat)"]
    },
    {
      day: "Day 14 - Sunday, November 15",
      text: [
        "Drive back to Tel Aviv with stops at:",
        "Tabernacle at Timna Park",
        "Tel of ancient Beersheba",
        "(overnight near airport)"
      ]
    },
    { day: "Day 15 - Monday, November 16", text: ["Fly home"] }
  ];

  const params = useParams();

  let dates = "";
  let itinerary = "";
  let trip = [];
  let supplement = [];
  console.log(params.trip);

  switch (params.trip) {
    case "September-2026":
      dates = "September 29 - October 10, 2026";
      trip = tripSeptember;
      supplement = supplementTripSeptember;
      break;
    case "October-2026":
      dates = "October 20 - 30, 2026";
      trip = tripOctober;
      supplement = null;
      break;
    case "November-2026":
      dates = "November 2 - 13, 2026";
      trip = tripNovember;
      supplement = supplementTripNovember;
      break;
    case "trip":
      dates = "";
      trip = tripExample;
      supplement = supplementTrip;
      break;
  }

  // useEffect(() => {
  //   if (params.trip === "trip") {
  //     setJustTrip(true);
  //     console.log(trip);
  //   } else {
  //     setJustTrip(false);
  //     console.log(trip);
  //   }
  // }, []);
  return (
    <div className="pageContainer">
      <p className="title">Holy Land Tour</p>
      <p className="secondaryTitle">{dates}</p>
      {/* DAY */}

      {trip.map((item, i) => (
        <div key={i} className={styles.IsraelItinerary}>
          <h2 className={styles.dayNumber}>{item.day}</h2>
          <ul className={styles.list}>
            {item.text.map((par, i) => (
              <li className={styles.listItem} key={i}>
                {par}
              </li>
            ))}
          </ul>
          {/* {item.picture ? (
            <button
              className={styles.popUpBtn}
              onClick={() => {
                open(i);
              }}
            >
              Read more...
            </button>
          ) : (
            ""
          )} */}

          {/*Box */}
          {/* <div
            className={styles.popUpBoxLong}
            style={{ display: boxState[i] ? "flex" : "none" }}
          >
            <div className={styles.innerBox}>
              <IoClose
                className={styles.icon}
                onClick={() => {
                  close(i);
                }}
              />
              <img
                className={styles.pictureFloat}
                src={item.picture}
                alt="Athens"
              />
              {item.extraText.map((par, i) => (
                <p className="text" key={i}>
                  {par}
                </p>
              ))}
            </div>
          </div> */}
        </div>
      ))}
      {supplement !== null ? (
        <div>
          <p className="secondaryTitle">SUPPLEMENT</p>
          {supplement.map((item, i) => (
            <div key={i} className={styles.IsraelItinerary}>
              <h2 className={styles.dayNumber}>{item.day}</h2>
              <ul className={styles.list}>
                {item.text.map((par, i) => (
                  <li className={styles.listItem} key={i}>
                    {par}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default PetraIsraelItinerary;
